








































































import Vue from 'vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import { Getter, Action } from 'vuex-class'


import { MAXIMUM_NUMBER_OF_GROUPS } from '../../../../../../../../service-for-game-codebase/game-codebase-type-1-app/app-type-2-digital-currency-account/digital-currency-account-type-1-algorithms/algorithms-type-20-create-digital-currency-account-group/create-digital-currency-account-group-1'

const namespace = 'digitalCurrency'

@Component({
  components: {
    //
  }
})
class Groups2AddToGroupDialogContent extends Vue {

  @Prop({ default: '' }) selectedItemId?: string
  @Prop({ default: '' }) selectedItemType?: string

  @Getter('getActiveDigitalCurrencyAccount', { namespace }) getActiveDigitalCurrencyAccount?: any
  @Getter('getDigitalCurrencyAccountGroupList', { namespace }) getDigitalCurrencyAccountGroupList?: any
  @Getter('getIsItemAlreadyInGroup', { namespace }) getIsItemAlreadyInGroup?: any

  @Action('createDigitalCurrencyAccountGroup', { namespace }) createDigitalCurrencyAccountGroup?: any
  @Action('addItemToGroup', { namespace }) addItemToGroup?: any
  @Action('removeItemFromGroup', { namespace }) removeItemFromGroup?: any

  showCreateGroupItemList: boolean = false

  newGroupName: string = ''

  isValidGroupName: boolean = false

  selectedGroupItem: any = null

  errorMessage: string = ''

  get groupList () {
    const groupList = this.getDigitalCurrencyAccountGroupList(this.getActiveDigitalCurrencyAccount.accountId).map((group: any) => {
      return {
        groupId: group.groupId,
        groupName: group.groupName,
        isItemAlreadyInGroup: this.getIsItemAlreadyInGroup(this.getActiveDigitalCurrencyAccount.accountId, group.groupId, this.selectedItemId)
      }
    })
    return groupList
  }

  // Emit Toggle show content
  emitToggleShowContent ({ isVisible }: { isVisible: boolean }) {
    this.$emit('toggleShowContent', { isVisible })
  }

  showCreateGroupButton () {
    this.errorMessage = ''

    if (this.groupList.length >= MAXIMUM_NUMBER_OF_GROUPS) {
      this.errorMessage = `Cannot create more than ${MAXIMUM_NUMBER_OF_GROUPS} groups.`
      return
    }

    this.showCreateGroupItemList = true
  }

  async createGroup () {
    if (!this.isValidGroupName) {
      return
    }

    await this.createDigitalCurrencyAccountGroup(this.newGroupName).catch((errorMessage: any) => {
      this.errorMessage = errorMessage
    })

    this.showCreateGroupItemList = false
    this.newGroupName = ''
  }

  async addItemToSelectedGroup () {
    if (!this.selectedGroupItem) {
      return
    }

    await this.addItemToGroup({
      groupId: this.selectedGroupItem.groupId,
      itemId: this.selectedItemId,
      itemType: this.selectedItemType
    })

    Vue.set(this, 'selectedGroupItem', Object.assign({}, this.selectedGroupItem))
    Vue.set(this.selectedGroupItem, 'isItemAlreadyInGroup', true)
  }

  async removeItemFromSelectedGroup () {
    if (!this.selectedGroupItem) {
      return
    }

    await this.removeItemFromGroup({
      groupId: this.selectedGroupItem.groupId,
      itemId: this.selectedItemId
    })

    Vue.set(this, 'selectedGroupItem', Object.assign({}, this.selectedGroupItem))
    Vue.set(this.selectedGroupItem, 'isItemAlreadyInGroup', false)
  }

  requireInput (inputValue: any) {
    return !!inputValue || 'Must have input value'
  }

  requireLessThanN1Characters (inputValue: any) {
    return inputValue.length <= 30 || 'Must have less than 30 characters'
  }

  requireAlphanumericCharacters (inputValue: any) {
    const regularExpressionPattern = /^([a-zA-Z0-9 _-]+)$/

    return regularExpressionPattern.test(inputValue) || 'Must contain alphanumeric characters only'
  }
}

export default Groups2AddToGroupDialogContent


